import { useEffect, useState } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

const useUpcomingCount = ({ dateRange, selectedHosts }) => {
  const [upcomingCount, setUpcomingCount] = useState(0);

  useEffect(() => {
    if (!dateRange || selectedHosts.length === 0) return;
    const hostPersonUuids = selectedHosts.map((host) => host.value);
    caseTransformingAxios
      .post("/api/v4/reporting/open_house_dashboard/upcoming_count", { hostPersonUuids, ...dateRange })
      .then((res) => setUpcomingCount(res.data.data || 0))
      .catch(console.log);
  }, [dateRange, selectedHosts]);

  return upcomingCount;
};

export default useUpcomingCount;
